import { ProjectParameters } from 'ducks/types/store-types';

export const parameterValidate = ({
  is_required,
  is_encrypted,
  parameter_value,
  reference_type_id,
}: ProjectParameters[number]) => {
  if (!is_required || is_encrypted) {
    return false;
  }
  if (parameter_value || reference_type_id) {
    return false;
  }
  return true;
};

export const splitJobFilterName = (value: string) => value.split(' - ')[1].toLowerCase();
